export interface IBankAccount {
  name: string;
  bankAccountId: number;
  isEdited: boolean;
  wiringInstructions: string;
  fileId: number | null;
  legalBusinessName: string;
  isDefault: boolean;
  fileName?: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IBankAccount = {
  getDefault(): IBankAccount {
    return {
      name: '',
      bankAccountId: 0,
      isEdited: false,
      wiringInstructions: '',
      fileId: null,
      legalBusinessName: '',
      isDefault: false,
    };
  },
};
